export function getBoletoDownloadUrl(row) {
  const url = row?.UrlDownloadBoleto ?? row?.UrlBoleto;
  if (url == null) {
    return "";
  }

  return String(url).trim();
}

export function isBoletoDownloadAvailable(row) {
  return getBoletoDownloadUrl(row) !== "";
}

export function getBoletoNumeroTitulo(row) {
  const numero = row?.NumeroTitulo ?? row?.numeroTitulo;
  if (numero == null) {
    return "";
  }

  return String(numero).trim();
}
